exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".infoWrap {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url(" + require("../../assets/img/img_bg.png") + ") no-repeat;\n  background-size: 100% 100%;\n}\n.infoWrap .login-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99;\n}\n.infoWrap .access-box {\n  position: relative;\n  z-index: 999;\n}\n.infoWrap .access-box>div {\n  margin: 0 auto;\n  font-size: 18px;\n  color: #fff;\n  text-align: center;\n}\n.infoWrap .access-box .access-logo {\n  width: 250px;\n  font-size: 12px;\n}\n.infoWrap .access-box .access-context span {\n  margin: 0 4px;\n}\n.infoWrap .access-box .access-btn {\n  width: 100px;\n  height: 30px;\n  line-height: 30px;\n  background-color: rgba(255,255,255,0.2);\n  margin-top: 30px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/no_access.styl
// module id = 5271
// module chunks = 0